import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Form, Table } from "react-bootstrap";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Swal from "sweetalert2";
import SplitPane from "react-split-pane";
import Pagination from "../../../Pagination";
import UseToggle from "../../../../Hooks/UseToggle";
import UpdateStudyKitTypeMetadata from "./UpdateStudyKitTypeMetadata";
import AddNewStudyKitTypeMetadata from "./AddNewStudyKitTypeMetadata";
import DeletedStudyKitTypeMetadata from "./DeletedStudyKitTypeMetadata";
import StudyKitTypeMetadataActivities from "./StudyKitTypeMetadataActivities";
import { eiwrsKitTypeServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitTypeServices";

const StudyKitTypeMetadataDataList = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [kitTypeData, setKitTypeData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [kitTypeList, setKitTypeList] = useState([]);
  const [kitTypeCount, setKitTypeCount] = useState(0);
  const [deletedStudySiteKitType, setDeletedStudyKitType] = useState([]);
  const [deletedStudySiteKitTypeCount, setDeletedStudyKitTypeCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");
  const [kitTypeId, setKitTypeId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [kitTypeActivity, setKitTypeActivity] = useState([]);
  const [kitTypeActivityCount, setKitTypeActivityCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(kitTypeCount / itemsPerPage);

  const getEIWRSKitTypeMetadataData = async (e) => {
    setLoading(true);
    let data = await eiwrsKitTypeServices.getEIWRSKitTypeMetadataData(
      "active",
      studyId,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setKitTypeList(data?.data || []);
    setKitTypeCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedEIWRSKitTypeMetadataData = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await eiwrsKitTypeServices.getEIWRSKitTypeMetadataData(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedStudyKitType(data?.data || []);
    setDeletedStudyKitTypeCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "EIWRSKitTypeMetadata",
      studyId,
      kitTypeData?.kitTypeId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setKitTypeActivity(data?.data || []);
    setKitTypeActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  useEffect(() => {
    setActiveTab("activities");
  }, [kitTypeData]);

  useEffect(() => {
    getEIWRSKitTypeMetadataData();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreEIWRSKitTypeMetadata = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} Site Kit Type!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        let data =
          await eiwrsKitTypeServices.softDeleteRestoreEIWRSKitTypeMetadata(
            userData
          );
        if (data?.statusCode === 200) {
          getEIWRSKitTypeMetadataData();
          setKitTypeId("");
          getDeletedEIWRSKitTypeMetadataData();
          if (type === "restore") {
            getDeletedEIWRSKitTypeMetadataData(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add New"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setKitTypeId("");
            }}
            className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
              }`}
          />
          <div className="vr"></div>
          {kitTypeCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 250, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          {StudyMode === "DBP Mode" &&
            deletedStudySiteKitTypeCount > 0 &&
            <button
              onClick={() => {
                setToggle1();
                getDeletedEIWRSKitTypeMetadataData(
                  pageNumberDeleted,
                  itemsPerPageDeleted
                );
              }}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          }
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={kitTypeId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewStudyKitTypeMetadata getEIWRSKitTypeMetadataData={getEIWRSKitTypeMetadataData} />
          )}
          {loading ? (
            <PageLoader />
          ) : kitTypeCount === 0 ? (
            <NoDataFoundTable MSG={"Study Kit Type not found!"} />
          ) : kitTypeList?.length === 0 ? (
            <NoDataFoundTable MSG={"Search Study Kit Type not found!"} />
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>
                      Kit Type
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 2)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Edit
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 3)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {kitTypeList?.map((kitTypeData, index) => (
                    <tr
                      key={index}
                      title="View Details"
                      className={`${kitTypeData?.type !== "predefine" && "CP"} ${kitTypeId === kitTypeData?._id ? "highlighted" : ""
                        }`}
                      onClick={() => setIsFormOpen(false)}
                    >
                      <td
                        onClick={() => {
                          setKitTypeData(kitTypeData);
                          setKitTypeId(kitTypeData?._id);
                        }}
                        className="text-center"
                      >
                        {index + 1 + startIndex}.
                      </td>
                      <td
                        onClick={() => {
                          setKitTypeData(kitTypeData);
                          setKitTypeId(kitTypeData?._id);
                        }}
                      >
                        {kitTypeData?.type}
                      </td>
                      <td
                        className="text-center CP"
                        title={`Update ${kitTypeData?.kitType}`}
                        onClick={(e) => {
                          setKitTypeData(kitTypeData);
                          setToggle();
                          e.stopPropagation();
                        }}
                        style={{ pointerEvents: "auto" }}
                      >
                        <FaEdit className="text-muted" />
                      </td>
                      <td
                        className="text-center CP"
                        title={`Delete ${kitTypeData?.kitType}`}
                        onClick={(e) => {
                          softDeleteRestoreEIWRSKitTypeMetadata(
                            kitTypeData?._id,
                            "delete"
                          );
                        }}
                      >
                        <FaTrash className={"text-danger"} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={kitTypeCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {kitTypeId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setKitTypeId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <StudyKitTypeMetadataActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                kitTypeActivity={kitTypeActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                kitTypeData={kitTypeData}
                kitTypeActivityCount={kitTypeActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateStudyKitTypeMetadata
        Show={!toggle}
        Hide={setToggle}
        kitTypeData={kitTypeData}
        setKitTypeId={setKitTypeId}
        getEIWRSKitTypeMetadataData={getEIWRSKitTypeMetadataData}
        Title={"Update Study Site KitType"}
      />
      <DeletedStudyKitTypeMetadata
        Show={!toggle1}
        Hide={setToggle1}
        setKitTypeId={setKitTypeId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedStudySiteKitType={deletedStudySiteKitType}
        getDeletedEIWRSKitTypeMetadataData={getDeletedEIWRSKitTypeMetadataData}
        deletedStudySiteKitTypeCount={deletedStudySiteKitTypeCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreEIWRSKitTypeMetadata={softDeleteRestoreEIWRSKitTypeMetadata}
        Title={"Deleted Study Site KitType History"}
      />
    </>
  );
};

export default StudyKitTypeMetadataDataList;
